// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
import App from './App'
import router from './router'
import "./service"
import * as utils  from './config/utils';    //工具类
import  './config/rem';
import store from './store';
Vue.use(Vuex);
Vue.config.productionTip = false;
import _ from 'lodash';
Vue.use(_);
/*
//  "mint-ui": "^2.2.13",暂时放弃使用mint-ui*/
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)


import Cube from 'cube-ui'
import 'cube-ui/lib/style.css'
Vue.use(Cube);




global.handsomeLong={
  loading:{},
  onlyVipCanQuery:true
};
/* eslint-disable no-new */
var vm=new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
});
for (let key in utils) {
  Vue.prototype[key] = utils[key];
}

let messageLongOriginal=vm.$message;
Vue.prototype.$message= function(options){
  if(typeof options=="string"){
    return messageLongOriginal({
      message:options,
      type:'info',
      duration:1500,
    });
  }else if(typeof options=="object"&&options.duration==undefined){
    return messageLongOriginal(Object.assign({},options,{duration:1500}));
  } else{
    return messageLongOriginal(options);
  }
};



// WEBPACK FOOTER //
// ./src/main.js